export default (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return value;
  
  // remove %, commas, and spaces
  const cleanValue = String(value).replace(/[%,\s]/g, '');
  const numValue = Number(cleanValue);
  
  return isNaN(numValue) ? null : numValue;
};